import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AbstractControl, FormGroup } from '@angular/forms';
import { NgSelectConfig } from '@ng-select/ng-select';
import utils from 'src/app/helpers/utils';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  @Input() items: UserProps[] = [];
  @Input() selected: string = '';

  @Input() id?: string = utils.makeID();
  @Input() name?: string;
  @Input() placeholder: string = 'Selecione';
  @Input() type = 'text';
  @Input() isActive: boolean = false;
  @Input() isSearching: boolean = false;
  @Input() maxLength: number = 150;
  @Input() min?: number | string;
  @Input() max?: number | string;

  // Form control
  @Input() controlName: string = '';
  //   @Input() group?: any;
  @Input() group?: any = new FormGroup({});

  @Input() helpText?: string;

  @Output() onClick = new EventEmitter<MouseEvent>();
  @Output() changeValue = new EventEmitter<MouseEvent>();
  @Output() valueChange = new EventEmitter<string>();

  visibleItems: UserProps[] = [];
  @Input() columns: TableColumnList<any>[] = [];
  gridTemplate = 'repeat(auto-fit, 1fr)';
  columnsToDisplay: TableColumnList<any>[] = [];
  footerColumnsToDisplay: TableColumnList<any>[] = [];

  constructor(config: NgSelectConfig, private sanitizer: DomSanitizer) {
    config.notFoundText = 'Nenhum item encontrado';

    config.bindLabel = 'label';
    config.bindValue = 'value';
  }

  getSafeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  ngOnInit(): void {
    this.visibleItems = this.items;

    const newColumns = [...this.columns].map((column) => ({
      ...column,
      size: column.size || 1,
    }));

    const gridTemplate = newColumns
      .map((column) => `${column.size}fr`)
      .join(' ');
    this.gridTemplate = gridTemplate;

    const newFooterColumns = [...this.columns];

    newFooterColumns.push({ name: '', cell: () => '' });

    this.columnsToDisplay = newColumns;
    this.footerColumnsToDisplay = newFooterColumns;
  }

  ngOnChanges(changes): void {
    this.visibleItems = this.items;
  }

  ngDoCheck(): void {
    this.visibleItems = this.items;
  }

  click(event: MouseEvent) {
    this.onClick.emit(event);
  }

  onInputValueChange(event: Event) {
    const value = (event.target as HTMLInputElement)?.value ?? '';
    this.valueChange.emit(value);
  }

  selectItem(id: any, event: MouseEvent) {
    event.stopPropagation();
    
    // Verificar se o item está desabilitado (representante ou colaborador)
    const item = this.visibleItems[id];
    if (item && this.isItemDisabled(item)) {
      // Não emitir evento para itens desabilitados
      return;
    }
    
    this.changeValue.emit(id);
  }

  getRequired(): boolean {
    const control = this.group.controls[this.controlName];

    if (control && control.validator) {
      let required = false;

      const validator = control.validator({} as AbstractControl);

      if (validator && validator.required) {
        required = true;
      }

      return required;
    }
    return false;
  }

  getGrid() {
    return {
      'grid-template-columns': this.gridTemplate,
    };
  }

  hasSearched(): boolean {
    const control = this.group?.controls[this.controlName];
    return control && control.value && control.value.trim().length > 0;
  }

  /**
   * Verifica se o item é desabilitado (apenas colaborador/admin)
   * Representante é clicável e vai para a tela de detalhes
   */
  isItemDisabled(item: UserProps): boolean {
    return item.applicable === 'admin';
  }

  /**
   * Retorna o tooltip para itens desabilitados
   */
  getDisabledTooltip(item: UserProps): string {
    if (item.applicable === 'admin') {
      return 'Não é possível ver detalhes de um colaborador';
    }
    return '';
  }
}
